// Import the CSS module (renamed for clarity)
import responsiveFontSize from './responsiveFontSize.module.css';

export const Typography = ({
    title,
    textAlignCenter,
    textTransform,
    line,
    type,
    fontSize,
    color,
    weight,
    ...props }) => {
    // Create a dynamic class name if fontSize is provided.
    // For example, if fontSize is 16, then className becomes responsiveFontSize['px16']
    const fontSizeClassName = fontSize
        ? responsiveFontSize[`px${fontSize}`]
        : responsiveFontSize.px14; // fallback to a default class (ensure px14 exists)

    return (
        <p
            className={fontSizeClassName}
            style={{
                textAlign: textAlignCenter || "left",
                textTransform: textTransform || "normal",
                textDecorationLine: line || "none",
                color: color || "#181818",
                fontWeight: weight || "500",
            }}
            {...props}
        >
            {title}
        </p>
    );
};
